import { useClientStorage } from './useClientStorage'

export const useLocalStorage = (key, initialValue = '') =>
  useClientStorage(key, initialValue, 'local')
